module.exports = __webpack_public_path__ + "img/MGH-Nihonbashi-1.9d124a86.jpg";